/**
 * Component responsible to display a tooltip using the tooltip component from
 * garden
 */
import $ from 'jquery'

import Tooltip from 'garden/src/js/components/tooltip'

export default ($el) => $el.tooltip({ placement: $el.data('placement') })
